import { render, staticRenderFns } from "./StatusTransition.vue?vue&type=template&id=06b441e2&scoped=true"
import script from "./StatusTransition.vue?vue&type=script&lang=js"
export * from "./StatusTransition.vue?vue&type=script&lang=js"
import style0 from "./StatusTransition.vue?vue&type=style&index=0&id=06b441e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b441e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b441e2')) {
      api.createRecord('06b441e2', component.options)
    } else {
      api.reload('06b441e2', component.options)
    }
    module.hot.accept("./StatusTransition.vue?vue&type=template&id=06b441e2&scoped=true", function () {
      api.rerender('06b441e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/StatusTransition.vue"
export default component.exports